import type { ReactNode } from 'react';

import {
  downloadCtaBackground,
  downloadCtaBackground1440w,
  downloadCtaBackground2172w,
} from '../../assets/marketing/marketingSceneExport';
import './landingRef.css';

type Props = {
  h2: string;
  sub: string;
  storeBadges?: ReactNode | null;
};

const CTA_BG_SRCSET = `${downloadCtaBackground1440w} 1440w, ${downloadCtaBackground2172w} 2172w`;

export function FinalCtaBand({ h2, sub, storeBadges = null }: Props) {
  const headlineLines = h2.includes('\n') ? h2.split('\n').filter(Boolean) : [h2];

  return (
    <section className="footer-cta" aria-label={storeBadges ? 'Download Kynward' : 'Join Kynward'}>
      <picture className="footer-bg">
        <source type="image/webp" srcSet={CTA_BG_SRCSET} sizes="100vw" />
        <img
          className="footer-bg__img"
          src={downloadCtaBackground}
          sizes="100vw"
          alt=""
          decoding="async"
          loading="lazy"
          fetchPriority="low"
        />
      </picture>
      <div className="footer-scrim" aria-hidden />
      <div className="footer-inner footer-inner--cta">
        <div className="footer-cta__copy">
          <h2 className={'center-heading' + (headlineLines.length > 1 ? ' stacked-heading' : '')}>
            {headlineLines.map((line) => (
              <span key={line}>{line}</span>
            ))}
          </h2>
          <p className="footer-inner__sub footer-inner__sub--stores">{sub}</p>
          {storeBadges ? <div className="footer-cta__stores">{storeBadges}</div> : null}
        </div>
      </div>
    </section>
  );
}
